// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.single-field-form-with-list i {
  padding-right: 3px;
}

.single-field-form-list {
  margin-bottom: 20px;
}
.single-field-form-list__item {
  padding: 10px 15px;
  border: 1px solid #ddd;
  position: relative;
}
.single-field-form-list__item__text {
  display: inline-block;
  width: 75%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.single-field-form-list__item__remove {
  position: absolute;
  right: 0px;
  margin-right: 15px;
}`, "",{"version":3,"sources":["webpack://./../../libraries/components/dist/src/SingleFieldFormWithList/SingleFieldFormWithList.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;;AAIA;EACI,mBAAA;AADJ;AAGI;EACI,kBAAA;EACA,sBAAA;EACA,kBAAA;AADR;AAGQ;EACI,qBAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AADZ;AAIQ;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;AAFZ","sourcesContent":[".single-field-form-with-list {\n    i {\n        padding-right: 3px;\n    }\n}\n\n.single-field-form-list {\n    margin-bottom: 20px;\n\n    &__item {\n        padding: 10px 15px;\n        border: 1px solid #ddd;\n        position: relative;\n\n        &__text {\n            display: inline-block;\n            width: 75%;\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n        }\n\n        &__remove {\n            position: absolute;\n            right: 0px;\n            margin-right: 15px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
